export default {
    namespaced: true,
    state: {
        data: {
            nextClassDate: null,
            userData: null,
            professions: [],
            backpacks: [],
            userProgression: null
        }
    },
    getters: {
        data(state) {
            return state.data;
        },
    },
    mutations: {
        setValue(state, data) {
            state[data[0]] = data[1];
        },
        setData(state, data) {
            state.data = data
        }
    },
    actions: {
        setValue({ commit }, data) {
            commit('setValue', data)
        },
        setData({ commit }, data) {
            commit('setData', data)
        },
    }
};